import Home from '@/pages/home'


export default [
    {
        path: '/home',
        component: () => import('@/pages/home'),
        meta: {
            isActive: true,
            title: '首页'
        }
    },
    {
        path: '/activityCorrelation',
        component: () => import('@/pages/activityCorrelation'),
        meta: {
            title: '美育活动相关'
        }
    },
    {
        path: '/contestCorrelation',
        component: () => import('@/pages/contestCorrelation'),
        meta: {
            title: '知识竞赛相关'
        }
    },
    {
        path: '/registerCorrelation',
        component: () => import('@/pages/registerCorrelation'),
        meta: {
            title: '知识竞赛相关'
        }
    },
    {
        path: '/organize',
        component: () => import('@/pages/navigation/organize'),
        meta: {
            title: '组织结构'
        }
    },
    {
        path: '/active',
        component: () => import('@/pages/navigation/active'),
        meta: {
            title: '活动项目'
        }
    },
    {
        path: '/demand',
        component: () => import('@/pages/navigation/demand'),
        meta: {
            title: '作品要求'
        }
    },
    {
        path: '/process',
        component: () => import('@/pages/navigation/process'),
        meta: {
            title: '活动流程'
        }
    },
    {
        path: '/poetry',
        component: () => import('@/pages/navigation/poetry'),
        meta: {
            title: '诗词答题'
        }
    },
    {
        path: '/poetryDawn',
        component: () => import('@/pages/navigation/poetryDawn'),
        meta: {
            title: '诗词答题-晨曦'
        }
    },
    {
        path: '/poetryTwilight',
        component: () => import('@/pages/navigation/poetryTwilight'),
        meta: {
            title: '诗词答题-暮辉'
        }
    },
    {
        path: '/calligraphy',
        component: () => import('@/pages/navigation/calligraphy'),
        meta: {
            title: '书法活动'
        }
    },
    {
        path: '/art',
        component: () => import('@/pages/navigation/art'),
        meta: {
            title: '美术活动'
        }
    },
    {
        path: '/recite',
        component: () => import('@/pages/navigation/recite'),
        meta: {
            title: '朗诵活动'
        }
    },
    {
        path: '/essay',
        component: () => import('@/pages/navigation/essay'),
        meta: {
            title: '征文活动'
        }
    },
    {
        path: '/activeHonor',
        component: () => import('@/pages/navigation/activeHonor'),
        meta: {
            title: '活动荣誉'
        }
    },
    {
        path: '/honor',
        component: () => import('@/pages/navigation/honor'),
        meta: {
            title: '荣誉实拍'
        }
    },
    {
        path: '/submit',
        component: () => import('@/pages/navigation/submit'),
        meta: {
            title: '提交方式'
        }
    },
    {
        path: '/contact',
        component: () => import('@/pages/navigation/contact'),
        meta: {
            title: '提交方式'
        }
    },
    {
        path: '/nowTerm',
        component: () => import('@/pages/navigation/nowTerm'),
        meta: {
            title: '本届佳作'
        }
    },
    {
        path: '/beforeTerm',
        component: () => import('@/pages/navigation/beforeTerm'),
        meta: {
            title: '往届佳作'
        }
    },
    {
        path: '/overview',
        component: () => import('@/pages/navigation/overview'),
        meta: {
            title: '活动概述'
        }
    },
    {
        path: '/media',
        component: () => import('@/pages/navigation/media'),
        meta: {
            title: '媒体报道'
        }
    },
    {
        path: '/exemption',
        component: () => import('@/pages/navigation/exemption'),
        meta: {
            title: '免责须知'
        }
    },
    {
        path: '/scores',
        component: () => import('@/pages/scores'),
        meta: {
            title: '成绩查询'
        }
    },
    {
        path: '/NewsDetail',
        component: () => import('@/pages/navigation/NewsDetail'),
        meta: {
            title: '新闻详情'
        }
    },
    {
        path: '/',
        redirect: '/home'
    }
]